module.exports = {"colors":{"P1":"#000000","P2":"#192C3B","P3":"#52777D","P4":"#9EBBA9","P5":"#F4F4F4"}}


//////////////////
// WEBPACK FOOTER
// ./src/static/css/palette.json
// module id = 118
// module chunks = 185999747177868 233985820157477